import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7388c011"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Municipio")
], -1))
const _hoisted_2 = { id: "card-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_component = _resolveComponent("card-component")!
  const _component_masonry_wall = _resolveComponent("masonry-wall")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_masonry_wall, {
        items: _ctx.articles,
        "ssr-columns": 3,
        "column-width": 300,
        gap: 24
      }, {
        default: _withCtx(({ item }) => [
          _createVNode(_component_card_component, { article: item }, null, 8, ["article"])
        ]),
        _: 1
      }, 8, ["items"])
    ])
  ], 64))
}